"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const web3_1 = require("./api/chain/web3");
const account_1 = require("../../account");
const tx_fees_1 = require("./tx-fees");
const estimateMaxSpendableWithAPI = ({ account, parentAccount, transaction, }, api) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    switch (account.type) {
        case "Account": {
            const txKind = (_a = transaction === null || transaction === void 0 ? void 0 : transaction.model.kind) !== null && _a !== void 0 ? _a : "transfer";
            const txFee = yield (0, tx_fees_1.estimateTxFee)(api, mainAccount, txKind);
            switch (txKind) {
                case "stake.createAccount": {
                    const stakeAccRentExempt = yield (0, web3_1.getStakeAccountMinimumBalanceForRentExemption)(api);
                    return bignumber_js_1.default.max(account.spendableBalance.minus(txFee).minus(stakeAccRentExempt), 0);
                }
                default: {
                    const rentExemptMin = yield (0, web3_1.getAccountMinimumBalanceForRentExemption)(api, account.freshAddress);
                    return bignumber_js_1.default.max(account.spendableBalance.minus(txFee).minus(rentExemptMin), 0);
                }
            }
        }
        case "TokenAccount":
            return account.spendableBalance;
    }
    throw new Error("not supported account type");
});
exports.default = estimateMaxSpendableWithAPI;
//# sourceMappingURL=js-estimateMaxSpendable.js.map